module.exports = __webpack_public_path__ + "static/media/ss.cb7ec4fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ss.png
// module id = 1986
// module chunks = 0